<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <v-expansion-panels
          v-if="computedValue && computedValue.items"
          class="pa-2"
        >
          <v-expansion-panel
            v-for="(category, index) in computedValue.items"
            :key="index"
            class="mt-2 rounded-lg"
            @click="openDialog(index)"
          >
            <v-expansion-panel-header hide-actions>
              <!--          <v-btn :disabled="index === 0" class="me-2" icon max-width="32" @click.stop="moveUp(index)">-->
              <!--            <v-icon>mdi-chevron-up</v-icon>-->
              <!--          </v-btn>-->

              <div class="d-flex align-center">
                <v-img
                  :src="category.picture"
                  alt=""
                  aspect-ratio="1"
                  class="rounded-lg me-2"
                  max-width="48px"
                />

                <v-btn class="d-none d-md-block" outlined>
                  {{ $t("editCategory") }} {{ category.name }}
                </v-btn>

                <span class="d-md-none">{{ category.name }}</span>
              </div>
              <v-spacer />
              <!--          <v-btn :disabled="index === computedValue.items.length - 1" icon max-width="32" @click.stop="moveDown(index)">-->
              <!--            <v-icon>mdi-chevron-down</v-icon>-->
              <!--          </v-btn>-->

              <v-btn
                icon
                max-width="36"
                @click.stop="deleteCat(index, category.id)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>

              <!--          <v-btn icon max-width="36" title="کپی دسته‌بندی" @click.stop="copyCat(category, index)">-->
              <!--            <v-icon>mdi-content-copy</v-icon>-->
              <!--          </v-btn>-->
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>

        <make-special-category
          v-if="showAddCat"
          v-model="tempContent"
          :show.sync="showAddCat"
          @close="closeDialog"
          @input="changeCategory"
        />

        <special-category-product-manager
          v-if="
            computedValue && computedValue.items && computedValue.items.length
          "
          v-model="computedValue.items"
          :selected-index="tempIndex"
          :show.sync="showCatsManager"
          @close="tempIndex = null"
          @fetch="fetchSpecials"
        />

        <v-card-actions class="px-2 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              color="success"
              class="contentinfo"
              outlined
              @click="addNewRecord"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("addProduct") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-item-addNewRecord`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('addProduct')"
            />
          </div>
        </v-card-actions>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import MakeSpecialCategory from "@/view/components/adapters/specialCategory/makeSpecialCategory.vue";
import SpecialCategoryProductManager from "@/view/components/adapters/specialCategory/specialCategoryProductManager.vue";
import { mapState } from "vuex";

export default {
  name: "specialCategoryManager",

  components: { SpecialCategoryProductManager, MakeSpecialCategory },

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "specialCategotyManger",
      tempContent: null,
      tempIndex: null,
      dialog: false,
      showAddCat: false,
      showCatsManager: false,
      loading: false,
    };
  },

  mounted() {
    if (!this.value)
      this.computedValue = {
        title: this.$t("special_sale"),
        description: "",
        sectionColor: {
          backGround: "linear-gradient(to right , #350808, #1C107CFF)",
          text: "#fff",
        },
        items: [],
      };

    this.fetchSpecials();
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.computedValue = {
          ...this.computedValue,
          title: this.$t("special_sale"),
        };
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    fetchSpecials() {
      this.loading = true;

      this.$api
        .get("v1/testQr/category-special", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(({ data }) => {
          this.computedValue.items = data.data.map((item) => {
            return {
              ...item,
              products: item.products.map(({ name, gallery, pivot }) => {
                return {
                  name,
                  gallery,
                  ...pivot,
                  total_discount: Number(pivot.total_discount),
                };
              }),
            };
          });
        })
        .finally(() => (this.loading = false));
    },
    addNewRecord() {
      let moment = require("moment");

      this.tempContent = {
        name: "فروش ویژه",
        color: "#FF0000FF",
        status: "active",
        expire_at: moment().add(30, "days").format("YYYY-MM-DD HH:mm:ss"),
        icon: "mdi-sale",
        picture: "",
      };
      this.showAddCat = true;
    },
    openDialog(index) {
      // this.tempContent = this.computedValue.items[index]
      this.tempIndex = index;
      this.showCatsManager = true;
    },
    changeCategory(cat) {
      if (this.tempIndex != null)
        this.computedValue.items[this.tempIndex] = cat;
      else this.computedValue.items.push(cat);

      this.showAddCat = false;
      this.tempIndex = null;
      this.tempContent = null;
    },
    closeDialog() {
      this.showAddCat = false;
      this.tempIndex = null;
      this.tempContent = null;
    },
    async deleteCat(index, id) {
      if (await this.$modal.yesNo(this.$t("deleteCategory"))) {
        this.loading = false;

        if (id != null) {
          this.$api
            .delete("v1/testQr/category-special/delete", {
              params: {
                special_category_id: id,
              },
            })
            .then(({ data }) => {
              this.computedValue.items.splice(index, 1);
              this.$toast.success("دسته‌بندی با موفقیت حذف شد");
            })
            .finally(() => (this.loading = false));
        } else this.computedValue.items.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped></style>
